import { format } from 'date-fns'

import { type DispatchListDetailExEntity } from '@/libs/api'
import { DISPATCH_DETAIL_FRAME_TYPE } from '@/libs/api/types'

type DateLike = string | Date | null | undefined

export const toDateKey = (value: DateLike): string | null => {
  if (value instanceof Date) {
    return format(value, 'yyyy-MM-dd')
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()

    // 文字列が単純な yyyy-MM-dd の場合はそのまま返す
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed
    }

    // ISO 文字列などの場合は Date として解釈し、ローカル日付で返す
    const parsed = new Date(trimmed)
    if (!Number.isNaN(parsed.getTime())) {
      return format(parsed, 'yyyy-MM-dd')
    }
  }

  return null
}

export const isDeliveryDetailOnShippingDate = (
  detail: DispatchListDetailExEntity,
  shippingDate: DateLike
): boolean => {
  if (detail.frameType !== DISPATCH_DETAIL_FRAME_TYPE.DELIVERY) {
    return false
  }

  const shippingDateKey = toDateKey(shippingDate)
  if (!shippingDateKey) return false

  return detail.shipmentOrders.some((order) => {
    return toDateKey(order.group.shippingDate) === shippingDateKey
  })
}

export const filterDeliveryDetailsByShippingDate = (
  details: DispatchListDetailExEntity[],
  shippingDate: DateLike
) => {
  return details.filter((detail) =>
    isDeliveryDetailOnShippingDate(detail, shippingDate)
  )
}
